import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'FETCH_GENESETS',
  'CREATE_GENESET',
  'DELETE_GENESET',
  'UPDATE_GENESET',
  'FETCH_GENES',
  'VALIDATE_GENES',
]);

export default {
  ...asyncActions,
};
